// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mtygdlcdybufoqawdzsr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im10eWdkbGNkeWJ1Zm9xYXdkenNyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcxNDk4ODEsImV4cCI6MjA2MjcyNTg4MX0.QtNTTAnOMOePc4TzHIxeJd3c2JpNdeHz5Vv6JmdSx6A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);